var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.task.question)}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b',[_vm._v("\n                Az Ön által meghatározott vélemény:\n            ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.userTask.solution.opinion)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }